import type { TextFieldProps } from "@mui/material";
import TextField from "@mui/material/TextField";
import React, { forwardRef, type FC } from "react";

export type TextInputProps = Omit<TextFieldProps, "variant">;

export const TextInput: FC<TextInputProps> = forwardRef((props, ref) => (
  <TextField variant="outlined" {...props} ref={ref} />
));
